import { UserAssignmentStatus, type Assignment } from '@webapp2/shared/model'
import { computed } from 'vue'
import { state } from '../state'

export const assignmentsByCourseId = computed(() =>
  Object.values(state.assignments).reduce<{ [courseId: string]: Assignment[] }>((acc, assignment) => {
    const assignments = acc[assignment.courseId] ?? []
    assignments.push(assignment)
    acc[assignment.courseId] = assignments
    return acc
  }, {})
)

const currentUserAssignmentStatuses = computed(() => {
  const userId = state.user?.id
  if (!userId) {
    return []
  }
  return Object.values(state.userAssignmentStatuses).filter(status => status.userId === userId && !status.deleted)
})

export const incompleteAssignmentStatuses = computed(() =>
  currentUserAssignmentStatuses.value.filter(status => status.status !== UserAssignmentStatus.Completed)
)

export const soonestDueIncompleteStatusByCourseId = computed(() =>
  incompleteAssignmentStatuses.value.reduce<{ [courseId: string]: UserAssignmentStatus }>((acc, status) => {
    const assignment = state.assignments[status.assignmentId]
    if (!assignment) {
      return acc
    }
    const soonest = acc[assignment.courseId]
    if (!soonest || assignment.dueDate < state.assignments[soonest.assignmentId]!.dueDate) {
      acc[assignment.courseId] = status
    }
    return acc
  }, {})
)

export const latestCompletedStatusByCourseId = computed(() =>
  currentUserAssignmentStatuses.value.reduce<{ [courseId: string]: UserAssignmentStatus }>((acc, status) => {
    if (status.status !== UserAssignmentStatus.Completed) {
      return acc
    }
    const assignment = state.assignments[status.assignmentId]
    if (!assignment) {
      return acc
    }
    const latest = acc[assignment.courseId]
    if (!latest || status.completedDate! > latest.completedDate!) {
      acc[assignment.courseId] = status
    }
    return acc
  }, {})
)
